const MobileHeader = ({ children }: { children: React.ReactNode }) => {
  return (
    <header className="fixed left-0 right-0 top-0 z-20 flex h-16 w-full items-center justify-between border-b border-border/60 bg-background/85 px-4 shadow-[0_18px_50px_-38px_rgba(15,23,42,0.55)] backdrop-blur">
      {children}
    </header>
  );
};

export default MobileHeader;
